<script>
import VoucherService from '@/services/VoucherService';

export default {
    props: {
        context: {
            description: "Voucher object"
        },
        baseCurrency: {}
    },
    data() {
        return {
            sum: 0,
            selected: [], 
            error: false
        };
    },
    computed: {
        raw_data() {
            return this.context.raw_data;
        }
    },
    created() {
        this.context.raw_data.forEach((e, i) => {
            this.$set(this.selected, i, true);
        });

        this.$watch("selected", this.watchSelected);

        this.calculateSum();
    },
    methods: {
        watchSelected(nV, oV) {
            this.calculateSum();
        },
        calculateSum() {
            this.sum = 0;
            this.selected.forEach((e, k) => {
                const intval = parseInt(
                    this.context.raw_data[k]["amount"] * 100
                );

                if (e) {
                    this.sum = this.sum + intval;
                }
            });
            this.sum = this.sum / 100;
        },
        async updateAndExit() {
            try {
                this.error = false; 
                await VoucherService.PUT_updateAmounts(this.context.id, {
                    amount: this.sum,
                    orig_amount: this.orig_sum
                });
                this.$emit("close-reload");
            } catch (e) {
                this.error = true; 
                console.log("up am e", e);
            }
        }
    }
};
</script>

<template>
    <modal size="xxl" :show="true" @close="$emit('close')" class="budget-modal">
        <template slot="header">
            <div class="mr-3 text-danger" v-if="context.is_bounced">
                <i class="far fa-exclamation-triangle"></i>
                {{ $t("vouchers.notice_bounced") }}
            </div>
            <div>{{ $t("vouchers.show_voucher_ec_line_details") }}</div>
        </template>

        <template slot="default">
            <h3>{{ $t("vouchers.entries") }}</h3>

            <p>
                {{ $t("vouchers.explain_justify_amount_in_entries") }}
            </p>

            <div class="d-flex justify-content-between text-warning">
                <div class="text-bold pb-1">
                    {{ $t("vouchers.saved_sum") }}:
                    {{
                        $n(context.amount, {
                            style: "currency",
                            currency: context.currency,
                            currencyDisplay: "code"
                        })
                    }}
                </div>
                <div class="text-bold">
                    <base-button
                        v-if="sum != context.amount"
                        @click="updateAndExit"
                        class="mr-4"
                        size="sm"
                        type="success"
                        >{{ $t("vouchers.recalculate_and_exit") }}</base-button
                    >

                    {{ $t("vouchers.entry_sum") }}:
                    {{
                        $n(sum, {
                            style: "currency",
                            currency: context.currency,
                            currencyDisplay: "code"
                        })
                    }}
                    <div class="alert alert-danger mt-3" v-if="error">{{ $t('vouchers.error_cannot_update_amounts') }}</div>
                </div>
            </div>

            <v-table class="table table-mg mt-3">
                <v-thead>
                    <v-tr>
                        <v-th>{{ $t("vouchers.tbl_hdr_voucher_number") }}</v-th>
                        <v-th>{{ $t("vouchers.tbl_hdr_post_nr") }}</v-th>
                        <v-th>{{ $t("vouchers.tbl_hdr_entry_type") }}</v-th>
                        <v-th>{{ $t("vouchers.tbl_hdr_supp_invoice") }}</v-th>
                        <v-th>{{ $t("vouchers.tbl_hdr_date") }}</v-th>
                        <v-th>{{ $t("vouchers.tbl_hdr_description") }}</v-th>
                        <v-th class="text-right">{{
                            $t("vouchers.tbl_hdr_amount")
                        }}</v-th>
                        <v-th class="text-right">{{
                            $t("vouchers.tbl_hdr_amount_in_base_currency")
                        }}</v-th>
                        <v-th class="text-center">{{
                            $t("vouchers.tbl_include")
                        }}</v-th>
                    </v-tr>
                </v-thead>
                <v-tbody>
                    <v-tr v-for="(l, i) in raw_data" :key="i">
                        <v-td>{{ l.voucherNumber }}</v-td>
                        <v-td>{{ l.entryNumber }}</v-td>
                        <v-td>{{ l.entryType }}</v-td>
                        <v-td>
                            <template v-if="'supplierInvoiceNumber' in l">
                                {{ l.supplierInvoiceNumber }}
                            </template>
                            <template v-else>---</template>
                        </v-td>
                        <v-td>{{ $d(new Date(l.date), "short") }}</v-td>
                        <v-td>{{ l.text }}</v-td>

                        <v-td class="text-right">{{
                            $n(l.amount, {
                                style: "currency",
                                currency: l.currency,
                                currencyDisplay: "code"
                            })
                        }}</v-td>
                        <v-td class="text-right">{{
                            $n(l.amountInBaseCurrency, "twodec")
                        }}</v-td>
                        <v-td class="text-center"
                            ><input type="checkbox" v-model="selected[i]"
                        /></v-td>
                    </v-tr>
                </v-tbody>
            </v-table>

            <!-- Bounces show -->
            <div v-if="context.is_bounced && context.bounced_raw_data">
                <hr />
                <h3 class="text-danger">
                    {{ $t("vouchers.historical_entries") }}
                </h3>
                <p class="text-danger">
                    {{ $t("vouchers.historical_entries_explanation") }}
                </p>
                <v-table class="table table-mg mt-3">
                    <v-thead>
                        <v-tr>
                            <v-th>{{
                                $t("vouchers.tbl_hdr_voucher_number")
                            }}</v-th>
                            <v-th>{{ $t("vouchers.tbl_hdr_post_nr") }}</v-th>
                            <v-th>{{ $t("vouchers.tbl_hdr_entry_type") }}</v-th>
                            <v-th>{{
                                $t("vouchers.tbl_hdr_supp_invoice")
                            }}</v-th>
                            <v-th>{{ $t("vouchers.tbl_hdr_date") }}</v-th>
                            <v-th>{{
                                $t("vouchers.tbl_hdr_description")
                            }}</v-th>
                            <v-th class="text-right">{{
                                $t("vouchers.tbl_hdr_amount")
                            }}</v-th>
                            <v-th class="text-right">{{
                                $t("vouchers.tbl_hdr_amount_in_base_currency")
                            }}</v-th>
                        </v-tr>
                    </v-thead>
                    <v-tbody>
                        <v-tr
                            v-for="(l, i) in context.bounced_raw_data"
                            :key="i"
                        >
                            <v-td>{{ l.voucherNumber }}</v-td>
                            <v-td>{{ l.entryNumber }}</v-td>
                            <v-td>{{ l.entryType }}</v-td>
                            <v-td>
                                <template v-if="'supplierInvoiceNumber' in l">
                                    {{ l.supplierInvoiceNumber }}
                                </template>
                                <template v-else>---</template>
                            </v-td>
                            <v-td>{{ $d(new Date(l.date), "short") }}</v-td>
                            <v-td>{{ l.text }}</v-td>

                            <v-td class="text-right">{{
                                $n(l.amount, {
                                    style: "currency",
                                    currency: l.currency,
                                    currencyDisplay: "code"
                                })
                            }}</v-td>
                            <v-td class="text-right">{{
                                $n(l.amountInBaseCurrency, "twodec")
                            }}</v-td>
                        </v-tr>
                    </v-tbody>
                </v-table>
            </div>
            <div v-else-if="context.is_bounced && !context.bounced_raw_data">
                <hr />
                <div class="alert alert-warning alert-outline">
                    {{
                        $t(
                            "vouchers.bounced_but_no_historical_entries_available"
                        )
                    }}
                </div>
            </div>

            <pre v-if="false">{{ context }}</pre>
        </template>
    </modal>
</template>
